"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Component, PropSync, Mixins } from "vue-property-decorator";
import { PaymentController } from "@/service/newProdect";
import _ from "lodash";
import {
  AccountSessionMixins
} from "@/service/account-session";
let PaymentNewCostComponent = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.check_payment_tip = false;
  }
  mounted() {
  }
  show_tips() {
    this.check_payment_tip = true;
    setTimeout(() => {
      this.check_payment_tip = false;
    }, 2e3);
  }
  deleteCoupon() {
    this._options.selected.paymentCoupon = null;
    this.$emit("paymentChange");
  }
  deleteCode() {
    this._options.selected.paymentDiscountCode = "";
    this._options.selected.paymentCodeType = null;
    this.$emit("paymentChange");
  }
  deleteCard() {
    this._options.selected.paymentVdcard = null;
    this._options.selected.paymentType = "alipay";
    this.$emit("paymentChange");
  }
  openWindow(url) {
    window.open(url, "_blank");
  }
  paymentCreate() {
    if (!this._options.selected.paymentAgreement) {
      this.show_tips();
      return;
    }
    this.$emit("paymentCreate");
  }
  paymentCreateShop() {
    if (!this._options.selected.paymentAgreement) {
      this.show_tips();
      return;
    }
    this.$emit("paymentCreateShop");
  }
  chooseCurrency(paymentType) {
    var _a;
    const paymentchoose = _.find((_a = this._options.selected.categorys) == null ? void 0 : _a.payments, { payment: paymentType });
    if (paymentchoose) {
      return paymentchoose.currency;
    } else {
      return "CNY";
    }
  }
};
__decorateClass([
  PropSync("options", {
    default: function() {
      return new PaymentController();
    }
  })
], PaymentNewCostComponent.prototype, "_options", 2);
__decorateClass([
  PropSync("paymentStyle", {
    default: function() {
      return "";
    }
  })
], PaymentNewCostComponent.prototype, "_payment_style", 2);
__decorateClass([
  PropSync("ready", {
    default: function() {
      return "";
    }
  })
], PaymentNewCostComponent.prototype, "_ready", 2);
__decorateClass([
  PropSync("shopId", { type: String, default: function() {
    return "";
  } })
], PaymentNewCostComponent.prototype, "shop_guid", 2);
PaymentNewCostComponent = __decorateClass([
  Component({
    filters: {
      numFilter: (value) => {
        if (value === "-") {
          return value;
        }
        return Number(value).toFixed(2);
      }
    }
  })
], PaymentNewCostComponent);
export {
  PaymentNewCostComponent as default
};
